import { useState } from 'react';
import { Button } from 'primereact/button';
import { Title } from 'components/Title';

import AdditionalItemsComponent from './AdditionalItemsComponent';
export default function AdditionalItemPage() {
	
	const [pageReady, setPageReady] = useState(true);
	const [showAdditionalItems, setShowAdditionalItems] = useState(false);
	return (
		<main id="AdditionalItemPage" className="main-page">
<section className="page-section q-pa-md" >
    <div className="container-fluid">
        <div className="grid ">
            <div className="col comp-grid" >
                <Title title="additional_item"   titleClass="text-lg font-bold text-primary" subTitleClass="text-500"      separator={false} />
                <div className="">
                    <AdditionalItemsComponent
                        visible={showAdditionalItems}
                        onHide={() => setShowAdditionalItems(false)}
                        onSuccess={(data) => {
                        console.log('Additional items added:', data);
                        // Refresh your order list or show success message
                        setShowAdditionalItems(false);
                        }}
                        />
                        <Button
                        label="Add Additional Items"
                        icon="pi pi-plus-circle"
                        className="p-button-info"
                        onClick={() => setShowAdditionalItems(true)}
                        />
                    </div>
                </div>
            </div>
        </div>
    </section>
		</main>
	);
}
